import styled from "styled-components";
export const Overlay = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  ${({ isExpanded }) => (isExpanded ? "display:block" : "display:none")}
`;
export const ListWrap = styled.div`
  padding: 48px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  height: 100%;
  &.side-panel-expanded {
    position: fixed;
    left: 0;
    right: 0;
    width: 240px;
    top: 0;
    bottom: 0;
    background: white;
    box-shadow: 0 5px 8px 0 rgb(0 0 0 / 15%);
    h3 {
      display: inline-block;
    }
  }
  .hamburger-menu {
    display: none;
  }
  .logo-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 36px;
    .close-icon{
      display: none;
    }

    img {
      flex-grow: 0;
      object-fit: contain;
      max-width: 136px;
    }
    h3 {
      background-image: linear-gradient(to top, #27397d, #0597c9);
      font-family: Poppins;
      font-size: 16px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.13;
      letter-spacing: normal;
      text-align: left;
      -webkit-background-clip: text;
      background-clip: text;
      margin-left: -42px;
      margin-top: -8px;
      -webkit-text-fill-color: transparent;
    }
  }
  .logout-wrapper {
    padding: 16px;
    padding-left: 4px;
    color: #3060e5;
    margin-top: auto;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    display: none;
  }
  .narayana-logo {
    margin-top: auto;
  }
  @media screen and (max-width: 1240px) {
    width: 48px;
    min-width: 48px;
    padding: 16px;
    .logout-wrapper {
      display: flex;
    }
    .logo-wrap {
      align-items: center;
      margin-bottom: 32px;
      justify-content: space-between;
      .close-icon{
        margin-right: 2px;
        display: flex;
      }
    }
    .narayana-logo {
      margin-top: 0;
    }
  }
`;
export const StyledLi = styled.li`
  width: 100%;
  list-style-type: none;
  border-radius: 16px;
  overflow: hidden;
  &.active-route {
    pointer-events: none;
    .nav-link.active {
      color: #2b2928 !important;
      font-weight: 400;
    }
    .nav-link {
      width: 100%;
      height: 100%;
      color: #2b2928 !important;
      background-color: #d3e2fd;
      display: flex !important;
      align-items: center;
      h3 {
        color: #2b2928 !important;
        font-weight: 400;
      }
      svg {
        path {
          stroke: #fff;
        }
      }
    }
  }
  &.normal-route {
    .nav-link {
      width: 100%;
      height: 100%;
      color: ${({ theme }) => theme.palette.grey[900]} !important;
      display: flex !important;
      align-items: center;

      h3 {
        color: #254082;
      }
      :hover {
        background-color: #f3f8ff;
      }
    }
  }
`;

export const RouteName = styled.h3`
  margin-left: 15px;
  padding-top: 6px;
  padding-bottom: 6px;
  margin-bottom: 0;
  font-family: Poppins;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.85;
  letter-spacing: normal;
  text-align: left;
`;
